// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Cn from "rescript-classnames/src/Cn.bs.js";
import * as Util from "../../../common/util.bs.js";
import * as Curry from "@rescript/std/lib/es6/curry.js";
import * as CardZoomAnimation from "../../CardZoomAnimation.bs.js";
import $$Image from "next/future/image";
import * as JsxRuntime from "react/jsx-runtime";

function CategoryMore(props) {
  var toggleMorePanel = props.toggleMorePanel;
  var morePanelOpen = props.morePanelOpen;
  var category = props.category;
  var isSelected = morePanelOpen === true;
  var setSelectedStyle = function (checked) {
    return Cn.make([checked ? "border-prezzee-blue text-white" : ""]);
  };
  var setSelectedTextStyle = function (checked) {
    return Cn.make([checked ? "text-prezzee-blue" : ""]);
  };
  return JsxRuntime.jsx(CardZoomAnimation.make, {
              children: JsxRuntime.jsx("div", {
                    children: JsxRuntime.jsx("div", {
                          children: JsxRuntime.jsxs("div", {
                                children: [
                                  JsxRuntime.jsx("div", {
                                        children: JsxRuntime.jsx($$Image, {
                                              src: category.img,
                                              alt: category.name,
                                              width: 200,
                                              height: 200,
                                              className: Cn.make([
                                                    props.iconClassName,
                                                    setSelectedStyle(isSelected)
                                                  ])
                                            }),
                                        className: Cn.make([
                                              "rounded-full h-10 w-10 p-2 border-white-smoke border-0 mb-3 flex items-center justify-center mx-auto shadow-light",
                                              setSelectedStyle(isSelected)
                                            ])
                                      }),
                                  JsxRuntime.jsx("p", {
                                        children: Util.ReactStuff.s(category.name),
                                        className: Cn.make([
                                              "text-center text-dark-gray text-sm",
                                              setSelectedTextStyle(isSelected)
                                            ])
                                      })
                                ]
                              }),
                          className: "cursor-pointer",
                          htmlFor: category.name,
                          onClick: (function (param) {
                              Curry._1(toggleMorePanel, (function (param) {
                                      return !morePanelOpen;
                                    }));
                            })
                        })
                  }, category.name)
            });
}

var Link;

var Img;

var make = CategoryMore;

export {
  Link ,
  Img ,
  make ,
}
/* Util Not a pure module */
